import Vue from 'vue';

const EventBus = new Vue();

export { EventBus };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/event-bus.js